// assets/ud-cart-bundle.js
import { CartUpdateEvent } from '@theme/events';

// Removes every cart line in a bundle group with one request. Zeroing all keys via
// /cart/update.js is atomic, unlike looping /cart/change.js where each removal shifts
// the remaining line indexes.
// Expand/collapse the breakdown. A button plus a sibling list rather than
// details/summary, so the open list can span the full width of the card grid.
document.addEventListener('click', (event) => {
  const toggle = event.target instanceof Element && event.target.closest('[data-ud-bundle-toggle]');
  if (!toggle) return;

  const list = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!list) return;

  const open = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!open));
  list.hidden = open;
});

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element && event.target.closest('[data-ud-bundle-remove]');
  if (!button) return;

  const keys = button.dataset.udBundleRemove.split(',').filter(Boolean);
  if (!keys.length) return;

  button.disabled = true;

  try {
    const sections = [...document.querySelectorAll('cart-items-component')]
      .map((element) => element.dataset.sectionId)
      .filter(Boolean)
      .join(',');

    const response = await fetch(`${Theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: Object.fromEntries(keys.map((key) => [key, 0])),
        sections,
        sections_url: window.location.pathname,
      }),
    });
    const cart = await response.json();

    button.dispatchEvent(
      new CartUpdateEvent(cart, 'ud-cart-bundle', {
        source: 'ud-cart-bundle',
        itemCount: cart.item_count,
        sections: cart.sections,
      })
    );
  } catch (error) {
    console.error(error);
    button.disabled = false;
  }
});
